// extracted by mini-css-extract-plugin
export default {"wrapper":"Alert_wrapper__A0COH","borderWrapper":"Alert_borderWrapper__5IpHY","heading":"Alert_heading__4h9n8","text":"Alert_text__RN6Wk","button":"Alert_button__Hk4dn"};